import { PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import { Currency, GameLifecycleStage } from '@Global/apollo/types';

export type GamesFilterInitialState = {
  isSingleMatch: boolean | null;
  price: number | null;
  currency: Currency | null;
  lifecycle?: GameLifecycleStage[] | null;
  isNft?: boolean | null;
  isPvp?: boolean | null;
  isMAIN?: boolean;
  isListExpanded?: boolean;
};

export type GamesFilterSliceProto = {
  initialState: GamesFilterInitialState;
  reducers: SliceCaseReducers<GamesFilterInitialState>;
};

export type PriceOption = {
  amount: number;
  currency: Currency;
};

export const gamesFilterSliceProto: GamesFilterSliceProto = {
  initialState: {
    isSingleMatch: null,
    price: null,
    currency: null,
    lifecycle: [GameLifecycleStage.Ongoing, GameLifecycleStage.Upcoming, GameLifecycleStage.Finished],
    isNft: null,
    isPvp: null,
    isMAIN: true,
    isListExpanded: false,
  },
  reducers: {
    setIsSingleMatch: (state, action: PayloadAction<boolean | null>) => {
      state.isSingleMatch = action.payload;
    },
    setIsNft: (state, action: PayloadAction<boolean | null>) => {
      state.isNft = action.payload;
    },
    setPrice: (state, action: PayloadAction<PriceOption | null>) => {
      state.price = action.payload?.amount ?? null;
      state.currency = action.payload?.currency || null;
    },
    setLifecycle: (state, action: PayloadAction<GameLifecycleStage[] | null>) => {
      state.lifecycle = action.payload;
    },
    setIsPvp: (state, action: PayloadAction<boolean>) => {
      state.isPvp = action.payload;
    },
    setIsMAIN: (state, action: PayloadAction<boolean>) => {
      state.isMAIN = action.payload;
    },
    setIsListExpanded: (state, action: PayloadAction<boolean>) => {
      state.isListExpanded = action.payload;
    },
    reset: (state) => {
      state.isSingleMatch = null;
      state.isNft = null;
      state.price = null;
      state.lifecycle = [GameLifecycleStage.Ongoing, GameLifecycleStage.Upcoming, GameLifecycleStage.Finished];
      state.isPvp = null;
      state.isMAIN = true;
      state.isListExpanded = false;
    },
    setIsGameListExpanded: (state, action: PayloadAction<boolean>) => {
      state.isListExpanded = action.payload;
    },
  },
};
